import { clientFetch } from 'app/utils/client-fetch';
import { ArcadeListItem } from 'routes/arcades/interfaces';
import * as types from './types';
import config from 'app/config';

export const apiGetArcades = (): Promise<{ arcades: ArcadeListItem[] }> =>
    clientFetch({
        url: `${config.ARCADE_API_URL}/arcades`,
        type: types.GET_ARCADES
    });
